import { ContactCardProps } from '../../components/HelpPages/molecules/ContactCard';
import { ContactCardsBlockProps } from '../../components/HelpPages/organisms/ContactCardsBlock';
import { OptimizelyContactsBlock } from '../../types/optimizely/blocks/contactsBlock';
import { mapToContactCardProps } from './mapToContactCardProps';

export const mapToContactCardsProps = (
	optiBlock: OptimizelyContactsBlock,
): ContactCardsBlockProps => {
	let items: ContactCardProps[] = [];

	// title is mandatory - so if it is missing assume
	// the card is not there
	if (optiBlock.title1.value) {
		items.push(
			mapToContactCardProps(
				optiBlock.icon1.value,
				optiBlock.title1.value,
				optiBlock.textEditor1.value,
				optiBlock.linkLabel1.value,
				optiBlock.link1.value,
			),
		);
	}

	if (optiBlock.title2.value) {
		items.push(
			mapToContactCardProps(
				optiBlock.icon2.value,
				optiBlock.title2.value,
				optiBlock.textEditor2.value,
				optiBlock.linkLabel2.value,
				optiBlock.link2.value,
			),
		);
	}

	if (optiBlock.title3.value) {
		items.push(
			mapToContactCardProps(
				optiBlock.icon3.value,
				optiBlock.title3.value,
				optiBlock.textEditor3.value,
				optiBlock.linkLabel3.value,
				optiBlock.link3.value,
			),
		);
	}

	if (optiBlock.title4.value) {
		items.push(
			mapToContactCardProps(
				optiBlock.icon4.value,
				optiBlock.title4.value,
				optiBlock.textEditor4.value,
				optiBlock.linkLabel4.value,
				optiBlock.link4.value,
			),
		);
	}

	return {
		items,
		anchorId: optiBlock.anchorId,
	};
};
